import { Children, cloneElement } from 'react'

export default function FilterAccordion({ open, label, name, onToggle, children }) {
  return (
    <div className='filterAccordion'>
      <button className='flatBtn filterLabel' onClick={() => onToggle(name)}>
        {label}
        <svg width='10.281' height='5.141' viewBox='0 0 10.281 5.141' className='arrow'>
          <path d='M10.281,5.141H0L5.141,0Z' />
        </svg>
      </button>
      <div className='children'>{cloneElement(Children.only(children), { open })}</div>

      <style jsx>{`
        .filterAccordion {
          position: relative;
          padding: 0 1.5rem 2.4rem 1.2rem;
          overflow: hidden;
          border-bottom: 0.1rem solid var(--separator-line-color);
        }

        button.filterLabel {
          position: relative;
          width: 100%;
          padding: 2rem 0 0;
          text-align: left;
          outline: none;
          background: #fff;
          color: var(--secondary-text-color);
          font-size: 1.4rem;
          font-weight: 700;

          &:focus {
            color: var(--primary-color);

            svg.arrow {
              fill: var(--primary-color);
            }
          }

          svg.arrow {
            position: absolute;
            top: 2.7rem;
            right: 0;
            fill: var(--primary-text-color);
            transition: transform 0.2s;
          }
        }

        .children {
          padding: 2.4rem 0 0;
          opacity: 0;
          transition: opacity 0.3s, transform 0.3s;
        }
      `}</style>

      <style jsx>{`
        .filterAccordion {
          height: ${open ? 'auto' : 6.2}rem;
        }

        .filterLabel {
          svg.arrow {
            transform: ${open ? 'rotate(0)' : 'rotate(-180deg)'};
          }
        }

        .children {
          opacity: ${open ? 1 : 0};
          transform: ${open ? 'translateY(0)' : 'translateY(-2rem)'};
          visibility: ${open ? 'visible' : 'hidden'};
        }
      `}</style>
    </div>
  )
}
